const app = {
  state: {
    clientWidth: 0,
    sidebar: {
      opened: !+localStorage.getItem('sidebarStatus'),
      minOpen: false // 小屏时菜单状态
    },
    router: {
      currentPageName: 'index'
    },
    lang: {
      icon: '',
      type: ''
    },
    searchState: {
      show: false,
      params: ''
    },
    user: {
      userInfo: null,
      verifyToken: null,
      controlUserInfo:null,
      controlVerifyToken:null
    },
    logo: '',
    deviceStatus:null,
    activeType:null,
    activationType:null,
    deviceType:null,
    dataAcrossPage: {}
  },
  mutations: {
    SET_DATA_ACROSS_PAGE: (state,payload) => {
      state.dataAcrossPage = payload
    },
    setClientWidth(state, currentValue) {
      state.clientWidth = currentValue;
      // console.log(currentValue)
    },
    /**
     * 设置logo
     */
    SET_LOGO : (state,payload) => {
        state.logo = payload;
    },
    /**
     * 菜单的缩展
     */
    TOGGLE_SIDEBAR: state => {
      let winWidth = document.documentElement.clientWidth
      if (winWidth <= 600) {
        state.sidebar.minOpen = !state.sidebar.minOpen
        state.sidebar.opened = false
        localStorage.setItem('sidebarStatus', 0)
        return
      } else {
        if (state.sidebar.opened) {
          localStorage.setItem('sidebarStatus', 1)
        } else {
          localStorage.setItem('sidebarStatus', 0)
        }
        state.sidebar.opened = !state.sidebar.opened
      }
    },
    CLOSE_SLIDEBAR: state => {
      localStorage.setItem('sidebarStatus', 0)
      state.sidebar.opened = false
      state.sidebar.minOpen = false
    },
    OPEN_SLIDEBAR: state => {
      localStorage.setItem('sidebarStatus', 1)
      state.sidebar.opened = true
    },
    /**
     * 面包屑
     */
    GET_CURRENT_PAGE_NAME: (state, payload) => {
      state.router.currentPageName = payload
    },
    /**
     * 面包屑获得当前模块名称
     */
     GET_CURRENT_PAGE_MODULE: (state, payload) => {
      localStorage.setItem('moduleName',payload);
     },
    /**
     * 获取设备状态
     */
    GET_DEVICE_STATUS: (state, payload) => {
      state.deviceStatus = payload;
    },
    /**
     * 获取设备活动状态
     */
    GET_ACTIVE_STATUS: (state,payload) =>{
      state.activeType = payload;
    },
    /**
     * 获取设备激活状态
     */
    GET_ACTIVATION_STATUS: (state,payload) =>{
      state.activationType = payload;
    },
    /**
     * 获取选择设备类型
     */
    GET_DEVICE_TYPE: (state,payload) =>{
      state.deviceType = payload;
    },

    /**
     * 设置语言
     */
    SET_LANG: (state, payload) => {
      state.lang = payload
      localStorage.setItem('langJSON', JSON.stringify(payload))
    },
    // 设置过期时间为 8小时
    SET_USERID_TOKEN: (state,payload) => {
      localStorage.setItem('utn', payload.token); //设置token
      localStorage.setItem('uid', payload.userId); //设置用户id，
      localStorage.setItem('firstLogin', payload.firstLogin); //设置用户id，
    },
    CLEAR_USERID_TOKEN: (state) => {
      localStorage.removeItem('utn'); //设置token
      localStorage.removeItem('uid'); //设置用户id，
      localStorage.removeItem('firstLogin'); //设置用户id，
    },
    SET_VERYFYTOKEN: (state, verifyToken) => {
      state.user.verifyToken = verifyToken;
    },
    SET_USER_INFO: (state,userInfo) => {
      state.user.userInfo = userInfo;
    },
    SET_AVATAR: (state,avatar) => {
      state.user.userInfo.avator = avatar;
    },
    CONTROL_CLEAR_USERID_TOKEN: (state) => {
      localStorage.removeItem('cutn'); //清除token
      localStorage.removeItem('cuid'); //清除用户id，
      localStorage.removeItem('firstLogin'); //清除用户id，
    },
    CONTROL_SET_VERYFYTOKEN: (state, verifyToken) => {
      state.user.ControlVerifyToken = verifyToken;
    },
    CONTROL_SET_USER_INFO: (state,userInfo) => {
      state.user.controlUserInfo = userInfo;
    },
    CONTROL_SET_AVATAR: (state,avatar) => {
      state.user.controlUserInfo.avator = avatar;
    }
  },
  actions: {
    setDataAcrossPage: ({commit}, payload) => {
      commit('SET_DATA_ACROSS_PAGE', payload)
    },
    ToggleSideBar: ({commit}) => {
      commit('TOGGLE_SIDEBAR')
    },
    getCurrentPageName: ({commit}, payload) => {
      commit('GET_CURRENT_PAGE_NAME', payload)
    },
    setLang: ({commit}, payload) => {
      commit('SET_LANG', payload)
    },
    setUserInfo: ({commit},payload) => {
      commit('SET_USER_INFO', payload)
    }
  }
}

export default app
